<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Generate Akun Dosen
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="12"
          class="mb-md-0 mb-2 mt-2"
        >
           <h5>Fitur ini untuk membantu admin dalam membuat akun dosen secara otomatis dari data master dosen.</h5>
           <h5>Format default hasil generate akun : </h5>
           <h5>username : nip_dosen@portal-psikoui.com</h5>
           <h5>password : pmb#online</h5>
           <br>
           <h5>Dosen yang belum memiliki akun : {{total}} Dosen</h5>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          md="4"
          class="mb-md-0 mb-2 mt-2"
        >
          <b-button variant="primary" @click="generate()">Generate Akun</b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput,BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import {
  getTotalDosenTanpaAkun,
  generateDosen,
} from '@/connection-api/master'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    BFormInput,
    BButton,
  },
  data() {
    return {
      total: 0,
      filter: {},
      count: 0,
      jenisSidangOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Jenis Sidang --' },
        ],
      },
      statusJadwalOption: {
        selected: 'id',
        options: [
          { value: null, label: '--Pilih Status Jadwal Sidang --' },
        ],
      },
    }
  },
  props: {
    triggerFilter: {
      default: null,
    },
    dataFilter: {
      default: null,
    },
  },
  beforeCreate() {
    getTotalDosenTanpaAkun()
      .then(response => {
        if (response.data.success == true) {
          this.total = response.data.total
        }
      })
      .catch(error => console.log(error));
  },
  methods: {
    generate()
    {
      if(window.confirm('Apakah anda yakin?'))
      {
         generateDosen()
          .then(response => {
            if (response.data.success == true) {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Sync Dosen',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: 'Akun dosen berhasil dibuat',
                },
              })
              this.total = response.data.total
              setTimeout(() => {
                this.$router.go()
              }, 3000);
              
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Sync Dosen',
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: response.data.message,
                },
              })
            }
          })
          .catch(error => console.log(error));
      }
    },
    cari()
    {
      this.count += 1
      this.$emit('update:dataFilter', this.filter)
      this.$emit('update:triggerFilter', this.count)
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
